import { request } from '../../../../sharedLegacy/utils/api'
import {
  HTTPMethod,
  type APIResponse,
} from '../../../../sharedLegacy/utils/api.types'

const liveSectionEndpoint = () => ({
  add: () => '/api/2/live/section/add',
})

type AddRequest = {
  /** ID of the live event or webinar for the live section */
  live_id: number
}

type AddResponse = {
  /** ID of the live section created */
  live_section_id: number
}

export async function addHighlight(
  liveId: number
): Promise<{ liveSectionId: number }> {
  return new Promise((resolve, reject) => {
    request<AddRequest, APIResponse<AddResponse>>({
      method: HTTPMethod.POST,
      url: liveSectionEndpoint().add(),
      data: {
        live_id: liveId,
      },
      error: reject,
    })
      .then(({ data }) => resolve({ liveSectionId: data.live_section_id }))
      .catch(reject)
  })
}
